import React from 'react';
import '../styles/Tutorials.css'; 
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import videoPlay from '../images/videoPlay.png'
import thumbnail1 from "../images/thumbnail1.webp";
import thumbnail2 from "../images/thumbnail2.webp";
import thumbnail3 from "../images/thumbnail3.webp";

const Tutorials =  ()  => {
  const videos = [
    {
      id: 1,
      title: "Video Title",
      time: "7:23",
      tags: ["Biology", "Science", "Brain"],
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sit amet leo lorem.",
      thumbnail: thumbnail1,
      status: "Pending",
    },
    {
      id: 2,
      title: "Video Title",
      time: "7:23",
      tags: ["Biology", "Science", "Brain"],
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sit amet leo lorem.",
      thumbnail: thumbnail2,
      status: "Approved",
    },
    {
      id: 3,
      title: "Video Title",
      time: "7:23",
      tags: ["Biology", "Science", "Brain"],
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sit amet leo lorem.",
      thumbnail: thumbnail3,
      status: "Rejected",
    },
  ];

  return (
    <>
    <Navbar />
    <main className='tutorialsPage-container'>
        <div className="tutorialsPage">
        <h1>Tutorials</h1>

        <div className="tutorialsPage-videos-list">
            {videos.map((video) => (
            <div key={video.id} className= "tutorials-video-card">
                <div className='tutorials-video_thumbnail'>
                    <img src={video.thumbnail} alt="Thumbnail"/>
                </div>
                <div className="tutorials-video_details">
                <div className='tutorials-video_title_play'>
                    <div className='tutorials-video_title'>{video.title}</div>
                    <div className='tutorials-video_play'> <img src={videoPlay} alt="play"/></div>
                </div>
                <div className="tutorials-video-time">{video.time}</div>
                <div className="tutorials-video-tags">
                    {video.tags.map((tag, index) => (
                    <div key={index} className="tutorials-tag">
                        {tag}
                    </div>
                    ))}
                </div>

                <p>{video.description}</p>

            
                </div>
                <div className="tutorials_videos_status_buttons">
                    <div className="tutorials_videos_actions">
                        <button className="tutorials_approve">Watch Now</button>
                    </div>
                </div>

                </div>
            ))}
        </div>
        </div>
    </main>
    <Footer />
    </>
  );
};

export default Tutorials;